export default __webpack_public_path__ + "static/media/calculator.1016e657.png";